import classNames from 'classnames';
import { CSSProperties, useEffect, useState } from 'react';
import { ICheckedFilter, IMapKey, IRadioFilter, RadioFilterTypes } from 'types/location.js';
import { LegendHeaderAction } from './legend-action.js';
import { hasLegend, LegendsEnum } from './legend-types.js';
import { LegendsFilters } from './legends-filters.js';
import { LegendsKeys } from './legends-keys.js';

export interface ILegendProps {
  keys?: Array<IMapKey>;

  // Filter props
  checkboxFilters?: Array<ICheckedFilter>;
  checkboxFilterOnClick?: (filter: ICheckedFilter) => void;

  // Radio Button Marker Type props
  radioFilters?: Array<IRadioFilter>;
  radioActiveFilter?: string;
  radioFilterOnClick?: (radioFilter: RadioFilterTypes) => void;

  checkBoxFilterLabel?: string;
  radioFilterLabel?: string;

  // Other
  isFloating?: boolean;
  isRight?: boolean;
  noPadding?: boolean;

  // Sticky
  isSticky?: boolean;

  styles?: CSSProperties;
}

export const Legends = ({
  keys,
  checkboxFilters = [],
  checkBoxFilterLabel,
  checkboxFilterOnClick = (_: ICheckedFilter) => 0,
  isFloating,
  isRight,
  radioFilters = [],
  radioFilterLabel,
  radioActiveFilter,
  radioFilterOnClick = (_: RadioFilterTypes) => 0,
  isSticky,
  styles,
}: ILegendProps) => {
  const [selected, setSelectedLegend] = useState<LegendsEnum>();

  const selectLegend = (selectedLegend: LegendsEnum | undefined) => {
    setSelectedLegend((prevSelectedLegend) => {
      let newSelectedLegend = selectedLegend;

      // If the same one is clicked then deselect it
      if (prevSelectedLegend === selectedLegend) {
        newSelectedLegend = undefined;
      }

      return newSelectedLegend;
    });
  };

  useEffect(() => {
    selectLegend(undefined);
  }, [keys]);

  const legendClasses = classNames(
    'Legend',
    { 'Legend--floating': isFloating },
    { 'Legend--right': isRight },
    { 'js-sticky': isSticky },
  );

  return (
    <div className={legendClasses} style={styles}>
      <div className="Legend-actions">
        {hasLegend(keys) && (
          <LegendHeaderAction
            onClick={selectLegend}
            icon="key"
            label="Keys"
            active={selected}
            index={LegendsEnum.Keys}
          />
        )}
        {hasLegend(checkboxFilters, radioFilters) && (
          <LegendHeaderAction
            onClick={selectLegend}
            icon="filter"
            label="Filters"
            active={selected}
            index={LegendsEnum.Filters}
          />
        )}
      </div>

      {/* Active Legend */}
      {/* @TODO If 1 item, show that */}
      {/* @TODO If 2 or more items, show as an accordion, include padding */}
      <div style={{ maxWidth: '250px', minWidth: '100%' }}>
        {selected && (
          <>
            {selected === LegendsEnum.Keys && (
              <div className={classNames('Legend-body', { 'Legend-body--noPadding': keys?.length !== 1 })}>
                <LegendsKeys keys={keys} />
              </div>
            )}

            {selected === LegendsEnum.Filters && (
              <div className="Legend-body">
                <LegendsFilters
                  checkboxFilters={checkboxFilters}
                  checkboxFilterOnClick={checkboxFilterOnClick}
                  checkBoxFilterLabel={checkBoxFilterLabel}
                  radioFilters={radioFilters}
                  radioActiveFilter={radioActiveFilter}
                  radioFilterOnClick={radioFilterOnClick}
                  radioFilterLabel={radioFilterLabel}
                />
              </div>
            )}

            <div className="Legend-footer" onClick={() => selectLegend(undefined)}>
              Close
            </div>
          </>
        )}
      </div>
    </div>
  );
};
